import { render } from "./Restrooms.vue?vue&type=template&id=8cfe5c0e&lang=html"
import script from "./Restrooms.vue?vue&type=script&setup=true&lang=js"
export * from "./Restrooms.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__